export const DESTINATIONS_STORE_KEY = 'destinations';
export const DESTINATIONS_SERVICE_KEY = 'destinations';
export const DESTINATIONS_API_URL = '/api/v1/destination/';
